var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "form",
      {
        ref: "coupon_form",
        attrs: { method: _vm.form.method, action: _vm.form.action }
      },
      [
        _c("input", {
          attrs: { type: "hidden", name: "_token" },
          domProps: { value: _vm.csrf }
        }),
        _vm._v(" "),
        _vm.form.method == "patch"
          ? _c("input", {
              attrs: { type: "hidden", name: "_method", value: "patch" }
            })
          : _vm._e(),
        _vm._v(" "),
        _c("card-with-header", { staticClass: "card-cascade narrower mb-r" }, [
          _c(
            "header",
            {
              staticClass:
                "view gradient-card-header pt-3 pb-3 d-none d-md-block mb-3",
              class: {
                "primary-color": _vm.status == "active" || _vm.status == true,
                "disabled-color": _vm.status != "active" && _vm.status != true
              },
              attrs: { slot: "header" },
              slot: "header"
            },
            [
              _c(
                "div",
                {
                  staticClass:
                    "d-flex justify-content-between align-items-center"
                },
                [
                  _c("h4", { staticClass: "mb-0 text-capitalize" }, [
                    _vm._v(_vm._s(_vm.crud) + " coupon")
                  ]),
                  _vm._v(" "),
                  _c(
                    "BaseButtonRound",
                    {
                      attrs: {
                        title: "Select to disable tips",
                        tooltip: true,
                        cls: {
                          "ml-0 my-0 mr-1": _vm.tooltip,
                          "ml-0 my-0 mr-1 disabled": !_vm.tooltip
                        },
                        type: "div",
                        small: false
                      },
                      nativeOn: {
                        click: function($event) {
                          _vm.tooltip = !_vm.tooltip
                        }
                      }
                    },
                    [
                      _c("template", { slot: "content" }, [
                        _c("i", { staticClass: "material-icons" }, [
                          _vm._v("announcement")
                        ])
                      ])
                    ],
                    2
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("hr"),
              _vm._v(" "),
              _c("p", { staticClass: "mb-0" }, [
                _vm._v(
                  "\n                    Discount is applied to each qualifying item in the checkout basket. Thus preventing discounts on\n                    items that do not apply e.g "
                ),
                _c("strong", [_vm._v("Season tickets")])
              ])
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              {
                staticClass: "col-12 col-md-6 d-flex",
                attrs: { "data-ref": "wrapper" }
              },
              [
                _c("BaseSwitch", {
                  staticClass: "w-100 align-self-center",
                  attrs: {
                    tabindex: 0,
                    checked: _vm.status == "active" || _vm.status == true,
                    field: "status",
                    identifier: "status",
                    label: "Status",
                    switch_off: "Off",
                    switch_on: "active",
                    title: _vm.notifier(
                      "Coupon will be usable when active",
                      true
                    ),
                    tooltip: _vm.tooltip
                  },
                  on: { input_value: _vm.statusModel }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "col-12 col-md-6",
                attrs: { "data-ref": "wrapper" }
              },
              [
                _c("BaseInputWithIcon", {
                  staticClass: "my-md-0",
                  attrs: {
                    tabindex: 1,
                    label: "Allocation",
                    id: "allocated",
                    field: "allocated",
                    identifier: "allocated",
                    input_type: "number",
                    required: false,
                    title:
                      "Default unlimited by setting to zero or leaving blank",
                    tooltip: _vm.tooltip,
                    icon: "account_balance",
                    value: _vm.allocated,
                    error: false
                  },
                  on: { input_value: _vm.AllocationModel }
                })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col-12 col-lg-12" },
              [
                _c("BaseInputWithIcon", {
                  attrs: {
                    tabindex: 2,
                    autocomplete: "off",
                    label: "Name",
                    id: "coupon-id",
                    field: "coupon_data->lang->en_GB->title",
                    identifier: "title",
                    required: true,
                    value: _vm.title,
                    title: "Used to identify this coupon",
                    tooltip: _vm.tooltip,
                    error: _vm.errors.title
                  },
                  on: {
                    input_value: _vm.titleModel,
                    form_error: _vm.setInputError
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-12 col-lg-12 mb-4" },
              [
                _c("BaseCodeInput", {
                  attrs: {
                    tabindex: 3,
                    autocomplete: "off",
                    placeholder: "Voucher Code",
                    error: _vm.errors.code,
                    identifier: "code",
                    validate_text: "Validate",
                    field: "code",
                    value: _vm.code,
                    generate: true,
                    title: _vm.notifier(
                      "The code used to claim the discount",
                      true
                    ),
                    tooltip: _vm.tooltip,
                    btn_refresh: true,
                    col_input: "col-lg-6",
                    col_btn_wrapper: "col-lg-6",
                    col_refresh: "col-lg-4",
                    col_validate: "col-lg-8",
                    code_validate_url: _vm.url.code_validate,
                    code_generate_url: _vm.url.code_generate
                  },
                  on: {
                    input_value: _vm.codeModel,
                    state_valid: _vm.codeValidModel,
                    form_error: _vm.setInputError
                  }
                })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row" }, [
            _c("input", {
              attrs: { type: "hidden", name: "start_date" },
              domProps: { value: _vm.dates.start }
            }),
            _vm._v(" "),
            _c("input", {
              attrs: { type: "hidden", name: "end_date" },
              domProps: { value: _vm.dates.ends }
            }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-12 col-md-6" },
              [
                _c("BaseDatePicker", {
                  attrs: {
                    tabindex: 4,
                    set_date: _vm.dates.start,
                    field: "start_date_fn",
                    set_active: true,
                    set_now: true,
                    label: "Available from",
                    title: _vm.notifier(
                      "The voucher will be available availble from...",
                      true
                    ),
                    tooltip: _vm.tooltip
                  },
                  on: { input_value: _vm.dateStartSet }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.date_on_going,
                    expression: "!date_on_going"
                  }
                ],
                staticClass: "col-12 col-md-6"
              },
              [
                _c("BaseDatePicker", {
                  attrs: {
                    tabindex: 5,
                    field: "end_date_fn",
                    set_date: _vm.dates.end,
                    set_active: !_vm.date_on_going,
                    set_now: true,
                    label: "To",
                    title: _vm.notifier(
                      "If the day is the same as the start date,  it will expire at 1 second before midnight on the same day",
                      true
                    ),
                    tooltip: _vm.tooltip
                  },
                  on: { input_value: _vm.dateEndSet }
                })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col-12" },
              [
                _c("BaseSwitch", {
                  attrs: {
                    tabindex: 6,
                    field: "local->ongoing",
                    switch_on: "Is on going",
                    switch_off: "Discount Expires",
                    checked: _vm.date_on_going,
                    title: _vm.notifier(
                      "Select dicsount expires to set an end date",
                      true
                    ),
                    tooltip: _vm.tooltip
                  },
                  on: { input_value: _vm.dateOngoingModel }
                })
              ],
              1
            )
          ])
        ]),
        _vm._v(" "),
        _c("card-basic", { attrs: { cls: "mb-5" } }, [
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col-12 col-md-6" },
              [
                _c("BaseSwitch", {
                  attrs: {
                    tabindex: 7,
                    checked: _vm.season_ticket_allow,
                    field: "coupon_data->allow_season_tickets",
                    label: "Allow Season tickets?",
                    switch_off: "nope",
                    switch_on: "allowed",
                    title: _vm.notifier(
                      "You must be absolutely sure that you wish to allow coupons on season tickets",
                      "warning"
                    ),
                    tooltip: _vm.tooltip
                  },
                  on: { input_value: _vm.seasonTicketAllow }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "col-12 col-md-6" })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col-12 col-md-6" },
              [
                _c("material-select", {
                  ref: "coupon_assigned_to_select",
                  attrs: {
                    id: "coupon_assigned_to",
                    title:
                      "Attention. If you choose All then everything in the checkout will qualify for the discount",
                    tooltip: _vm.tooltip
                  },
                  on: { material_select_result: _vm.couponAssigned }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "col-12 col-md-6" }, [
              _c(
                "div",
                {
                  class: {
                    "d-none": _vm.wrappers.ticket.cls != true
                  },
                  attrs: { id: _vm.wrappers.ticket.id }
                },
                [
                  _c("material-select", {
                    ref: "coupon_tickets_select",
                    attrs: {
                      tabindex: 8,
                      id: "coupon_tickets_select",
                      title: "Select tickets to be illegible for discount"
                    },
                    on: { material_select_result: _vm.couponTicketsModel }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  class: {
                    "d-none": _vm.wrappers.entity.cls != true
                  },
                  attrs: { id: _vm.wrappers.entity.id }
                },
                [
                  _c("material-select", {
                    ref: "coupon_entities_select",
                    attrs: {
                      tabindex: 9,
                      id: "coupon_entities_select",
                      title:
                        "Warning. All tickets (excluding season tickets unless enabled) assigned to the selected entities will qualify for discount"
                    },
                    on: { material_select_result: _vm.couponEntitiesModel }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  class: {
                    "d-none": _vm.wrappers.event.cls != true
                  },
                  attrs: { id: _vm.wrappers.event.id }
                },
                [
                  _c("material-select", {
                    ref: "coupon_events_select",
                    attrs: {
                      tabindex: 10,
                      id: "coupon_events_select",
                      title:
                        "Warning. All tickets (excluding season tickets unless enabled) assigned to the selected events will qualify for discount",
                      tooltip: _vm.tooltip
                    },
                    on: { material_select_result: _vm.couponEventsModel }
                  })
                ],
                1
              )
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "row",
              attrs: { "data-ref": "discount type selector and value" }
            },
            [
              _c(
                "div",
                { staticClass: "col-12 col-md-6" },
                [
                  _c("material-select", {
                    ref: "discount_type_select",
                    attrs: {
                      tabindex: 11,
                      id: "discount_type",
                      title:
                        "If you choose All then everything in the checkout will qualify for the discount",
                      tooltip: _vm.tooltip
                    },
                    on: { material_select_result: _vm.discountType }
                  })
                ],
                1
              ),
              _vm._v(" "),
              !_vm.free_discount
                ? [
                    _c(
                      "div",
                      { staticClass: "col-12 col-md-6" },
                      [
                        _c("BaseInputWithIcon", {
                          attrs: {
                            tabindex: 12,
                            label: "Discount Amount",
                            id: "discount_value",
                            value: _vm.discount_value,
                            error: _vm.errors.discount_value,
                            identifier: "discount_value",
                            icon: "card_membership",
                            field: "coupon_data->discount_value",
                            input_type:
                              _vm.discount_type === "price_reduction"
                                ? "money"
                                : "number",
                            title: "Enter the value amount",
                            tooltip: _vm.tooltip,
                            novalidate: true
                          },
                          on: {
                            form_error: _vm.setInputError,
                            input_value: _vm.discountValueModel
                          }
                        })
                      ],
                      1
                    )
                  ]
                : _vm._e()
            ],
            2
          ),
          _vm._v(" "),
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col-12 col-md-6 d-flex" },
              [
                _c("BaseSwitch", {
                  staticClass: "w-100 align-self-center",
                  attrs: {
                    field: "coupon_data->stackable",
                    tabindex: 14,
                    switch_on: "Not stackable",
                    switch_off: "Discounts can stack",
                    checked: true,
                    title: _vm.notifier(
                      "Multiple vouchers can be used at the same time when allowed to stack",
                      "warning"
                    ),
                    tooltip: _vm.tooltip
                  },
                  on: { input_value: _vm.statusModel }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-12 col-md-6" },
              [
                _c("BaseInputWithIcon", {
                  staticClass: "my-md-0",
                  attrs: {
                    tabindex: 13,
                    label: "On orders over",
                    id: "orders_over",
                    field: "coupon_data->orders_over",
                    input_type: "money",
                    required: false,
                    title:
                      "The qualifying assignment will apply the discount if the total value exceeds this amount",
                    tooltip: _vm.tooltip,
                    icon: "monetization_on",
                    value:
                      _vm.orders_over_pennies > 0
                        ? _vm.orders_over_pennies / 100
                        : 0
                  },
                  on: { input_value: _vm.ordersOverModel }
                })
              ],
              1
            )
          ])
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "fixed-action-btn-est btn-floating---submit ",
            staticStyle: { bottom: "45px", right: "24px" }
          },
          [
            _c(
              "a",
              {
                staticClass:
                  "animated pulse waves-effect waves-light btn-floating btn-floating--single btn-lg border-0 ",
                class: {
                  "btn-disabled": !_vm.can_submit
                },
                attrs: { type: "submit", id: "coupon--save" },
                on: {
                  click: function($event) {
                    _vm.submitForm()
                  }
                }
              },
              [
                _c(
                  "i",
                  {
                    staticClass: "material-icons",
                    attrs: { "aria-hidden": "true" }
                  },
                  [_vm._v("save")]
                )
              ]
            )
          ]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-14e4f988", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-14e4f988","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./resources/assets/js/components/pages/coupons/CouponCRUD.vue
// module id = 536
// module chunks = 0